module.exports = __webpack_public_path__ + "static/media/posthog.9f16ae02.svg";